<template>
  <flat-button icon="add" label="Voeg een externe link toe" />
</template>

<script>
export default {
  emits: ['addLinks'],
  data(){
    return {
      linkArray: []
    }
  }
}
</script>
